import { clsx } from "clsx";
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs));
}

// Normalize a phone number to the canonical display format `(xxx) xxx-xxxx`.
// Shared across Leads, Outbound, and any other surface that renders a phone
// so partners see one consistent shape no matter how the data was imported.
// - 10 digits                 -> `(xxx) xxx-xxxx`
// - 11 digits w/ leading `1`  -> `(xxx) xxx-xxxx` (strip the US country code;
//                                 LOs never want to see `+1` in the UI)
// - Anything else             -> returned as-is so bad/short data stays
//                                 visible for the LO to catch and fix (e.g.
//                                 the stray `2197412406` or truncated
//                                 `239-388-854` cases).
export function formatPhone(raw) {
  if (raw === null || raw === undefined || raw === '') return '—';
  const d = String(raw).replace(/\D/g, '');
  if (d.length === 10) return `(${d.slice(0, 3)}) ${d.slice(3, 6)}-${d.slice(6)}`;
  if (d.length === 11 && d.startsWith('1')) return `(${d.slice(1, 4)}) ${d.slice(4, 7)}-${d.slice(7)}`;
  return String(raw);
}
